import { useEffect, useRef, useState } from 'react';
import { AppContext } from '../../hooks/useAppContext';
import { useNavigate } from 'react-router-dom';
import WordService from '../../api/wordService';
import { Dropdown } from 'primereact/dropdown';
import React from 'react';

const LangsComponent = () => {
  const [langs, setLangs] = useState<string[]>([]);
  const loaded = useRef<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;
    fetch();
  });

  const fetch = async () => {
    const response = await WordService.getLangs();
    setLangs(response.map((l) => l.code));
  };

  if (langs.length === 0) {
    return null;
  }

  return (
    <AppContext.Consumer>
      {({ Lang, SetLang }) => (
        <div className="langs">
          <Dropdown
            name="lang"
            value={Lang}
            options={langs}
            onChange={(e) => {
              SetLang(e.target.value);
              navigate('/');
            }}
          />
        </div>
      )}
    </AppContext.Consumer>
  );
};

export default LangsComponent;
